const wall = 2;

export const Corners = [
  {
    x: 0,
    y: 0,
    w: wall,
    h: 8,
  },
  {
    x: 0,
    y: 92,
    w: wall,
    h: 8,
  },
  {
    x: 100 - wall,
    y: 0,
    w: wall,
    h: 8,
  },
  {
    x: 100 - wall,
    y: 92,
    w: wall,
    h: 8 - wall,
  },
  {
    x: wall,
    y: 0,
    w: 8 - wall,
    h: wall,
  },
  {
    x: 92,
    y: 0,
    w: 8 - wall,
    h: wall,
  },
  {
    x: wall,
    y: 100 - wall,
    w: 8 - wall,
    h: wall,
  },
  {
    x: 92,
    y: 100 - wall,
    w: 8,
    h: wall,
  },
];

export const BadBoxesBase = {
  //Walls & red words

  ///// LEVEL 1 /////
  level1: [
    {
      x: 30,
      y: 35,
      w: wall,
      h: 54,
      word: false,
    },
    {
      x: 30 + wall,
      y: 35,
      w: 40 - wall,
      h: wall,
      word: false,
    },
    {
      x: 30 + wall,
      y: 60,
      w: 70 - wall,
      h: wall,
      word: false,
    },
    {
      x: 70,
      y: 35,
      w: wall,
      h: 10,
      word: false,
    },
    {
      x: 10,
      y: 20,
      w: 0,
      h: wall,
      word: { nl: "Trio pack voor € 50", fr: "Pack trio € 50" },
    },
  ],

  ///// LEVEL 2 /////
  level2: [
    {
      x: 44,
      y: 18,
      w: wall,
      h: 40,
      word: false,
    },
    {
      x: 44,
      y: 18,
      w: 25,
      h: wall,
      word: false,
    },
    {
      x: 56,
      y: 30,
      w: wall,
      h: 30,
      word: false,
    },
    {
      x: 56,
      y: 30,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 66,
      y: 76,
      w: wall,
      h: 26,
      word: false,
    },
    {
      x: 26,
      y: 76,
      w: 40,
      h: wall,
      word: false,
    },
    {
      x: 26,
      y: 56,
      w: wall,
      h: 16,
      word: false,
    },
    {
      x: 18,
      y: 20,
      w: 0,
      h: wall,
      word: { nl: "10 GB", fr: "10 GB" },
    },
    {
      x: 18,
      y: 24,
      w: 0,
      h: wall,
      word: { nl: "data", fr: "data" },
    },
  ],

  ///// LEVEL 3 /////
  level3: [
    {
      x: 90,
      y: 14,
      w: wall,
      h: 20,
      word: false,
    },
    {
      x: 74,
      y: 14,
      w: 16,
      h: wall,
      word: false,
    },

    // 3 - tunnel left
    {
      x: 50,
      y: 60,
      w: wall,
      h: 30,
      word: false,
    },
    {
      x: 10,
      y: 30,
      w: 40,
      h: wall,
      word: false,
    },
    {
      x: 36,
      y: 46,
      w: wall,
      h: 26,
      word: false,
    },

    {
      x: 10,
      y: 46,
      w: 26,
      h: wall,
      word: false,
    },

    // 3 - tunnel right
    {
      x: 50,
      y: 60,
      w: 46,
      h: wall,
      word: false,
    },
    {
      x: 66,
      y: 76,
      w: wall,
      h: 60,
      word: false,
    },
    {
      x: 66,
      y: 76,
      w: 36,
      h: wall,
      word: false,
    },
    {
      x: 36,
      y: 76,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 50,
      y: 6,
      w: wall,
      h: 30,
      word: false,
    },

    {
      x: 64,
      y: 20,
      w: 0,
      h: wall,
      word: { nl: "Onbeperkt", fr: "Internet" },
    },

    {
      x: 64,
      y: 24,
      w: 0,
      h: wall,
      word: { nl: "internet", fr: "illimité" },
    },
  ],

  ///// LEVEL 4 /////
  level4: [
    // 4 - corner walls left
    {
      x: 10,
      y: 5,
      w: 60,
      h: wall,
      word: false,
    },
    {
      x: 10,
      y: 21,
      w: wall,
      h: 70,
      word: false,
    },

    // 4 - corner walls right
    {
      x: 50,
      y: 91,
      w: 40,
      h: wall,
      word: false,
    },
    {
      x: 90,
      y: 57,
      w: wall,
      h: 36,
      word: false,
    },

    // 4 - corner 1 - left down
    {
      x: 10,
      y: 69,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 26,
      y: 51,
      w: wall,
      h: 20,
      word: false,
    },

    // 4 - corner 2 - left down
    {
      x: 30,
      y: 81,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 46,
      y: 61,
      w: wall,
      h: 20,
      word: false,
    },

    // 4 - corner 3 - left up
    {
      x: 25,
      y: 39,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 45,
      y: 25,
      w: wall,
      h: 16,
      word: false,
    },

    // 4 - tunnel - down right
    {
      x: 54,
      y: 75,
      w: 28,
      h: wall,
      word: false,
    },
    {
      x: 60,
      y: 65,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 80,
      y: 65,
      w: wall,
      h: 10,
      word: false,
    },

    // 4 - corner 4 - right up
    {
      x: 60,
      y: 45,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 60,
      y: 31,
      w: wall,
      h: 16,
      word: false,
    },

    // 4 - dounle corner - left upß
    {
      x: 30,
      y: 5,
      w: wall,
      h: 16,
      word: false,
    },
    {
      x: 20,
      y: 21,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 60,
      y: 17,
      w: 0,
      h: wall,
      word: { nl: "Snoepjes", fr: "Des bonbons" },
    },
  ],

  ///// LEVEL 5 /////
  level5: [
    // 5 - kader rond doolhof
    {
      x: 25,
      y: 25,
      w: wall,
      h: 50,
      word: false,
    },
    {
      x: 81,
      y: 20,
      w: wall,
      h: 20,
      word: false,
    },
    {
      x: 93,
      y: 22,
      w: wall,
      h: 67,
      word: false,
    },
    {
      x: 81,
      y: 60,
      w: wall,
      h: 22,
      word: false,
    },
    {
      x: 25,
      y: 25,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 61,
      y: 20,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 25,
      y: 75,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 61,
      y: 80,
      w: 20,
      h: wall,
      word: false,
    },
    {
      x: 45,
      y: 75,
      w: wall,
      h: 5,
      word: false,
    },
    // 5 - kader buiten
    {
      x: 5,
      y: 8,
      w: wall,
      h: 80,
      word: false,
    },
    {
      x: 61,
      y: 8,
      w: wall,
      h: 26,
      word: false,
    },
    {
      x: 5,
      y: 8,
      w: 90,
      h: wall,
      word: false,
    },

    {
      x: 5,
      y: 88,
      w: 90,
      h: wall,
      word: false,
    },
    {
      x: 5,
      y: 38,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 15,
      y: 57,
      w: 10,
      h: wall,
      word: false,
    },

    // 5 - binnenin
    {
      x: 25,
      y: 62,
      w: 36,
      h: wall,
      word: false,
    },
    {
      x: 61,
      y: 52,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 59,
      y: 42,
      w: wall,
      h: 20,
      word: false,
    },
    {
      x: 35,
      y: 32,
      w: 36,
      h: wall,
      word: false,
    },
    {
      x: 71,
      y: 52,
      w: wall,
      h: 20,
      word: false,
    },

    {
      x: 61,
      y: 42,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 35,
      y: 45,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 10,
      y: 11,
      w: 0,
      h: wall,
      word: { nl: "Een", fr: "Un coussin" },
    },
    {
      x: 15,
      y: 19,
      w: 0,
      h: wall,
      word: { nl: "kersenpitkussen", fr: "noyaux de cerise" },
    },
  ],

  ///// LEVEL 6 /////
  level6: [
    // 6 - base
    {
      x: 46,
      y: 90,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 30,
      y: 86,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 56,
      y: 86,
      w: 16,
      h: wall,
      word: false,
    },

    // 6 - leaf left
    {
      x: 30,
      y: 80,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 16,
      y: 80,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 10,
      y: 66,
      w: wall,
      h: 10,
      word: false,
    },
    {
      x: 10,
      y: 76,
      w: 6,
      h: wall,
      word: false,
    },
    {
      x: 10,
      y: 66,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 24,
      y: 68,
      w: 14,
      h: wall,
      word: false,
    },

    // 6 - leaf right
    {
      x: 70,
      y: 80,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 70,
      y: 80,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 90,
      y: 66,
      w: wall,
      h: 10,
      word: false,
    },
    {
      x: 86,
      y: 76,
      w: 6,
      h: wall,
      word: false,
    },
    {
      x: 80,
      y: 66,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 64,
      y: 68,
      w: 14,
      h: wall,
      word: false,
    },

    // 6 - leaf left middle
    {
      x: 36,
      y: 60,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 26,
      y: 60,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 26,
      y: 56,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 16,
      y: 56,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 10,
      y: 40,
      w: wall,
      h: 8,
      word: false,
    },
    {
      x: 10,
      y: 40,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 26,
      y: 40,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 30,
      y: 46,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 40,
      y: 46,
      w: wall,
      h: 6,
      word: false,
    },

    // 6 - leaf right middle
    {
      x: 64,
      y: 60,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 64,
      y: 60,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 74,
      y: 56,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 74,
      y: 56,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 90,
      y: 40,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 76,
      y: 40,
      w: 16,
      h: wall,
      word: false,
    },
    {
      x: 76,
      y: 40,
      w: wall,
      h: 6,
      word: false,
    },
    {
      x: 60,
      y: 46,
      w: 10,
      h: wall,
      word: false,
    },
    {
      x: 60,
      y: 46,
      w: wall,
      h: 6,
      word: false,
    },

    // 6 - ;iddle leaf
    {
      x: 42,
      y: 32,
      w: wall,
      h: 12,
      word: false,
    },
    {
      x: 58,
      y: 32,
      w: wall,
      h: 12,
      word: false,
    },
    {
      x: 46,
      y: 20,
      w: 9,
      h: wall,
      word: false,
    },
    {
      x: 45,
      y: 20,
      w: wall,
      h: 7,
      word: false,
    },
    {
      x: 55,
      y: 20,
      w: wall,
      h: 7,
      word: false,
    },

    // 6 - middle wall
    {
      x: 51,
      y: 57,
      w: wall,
      h: 23,
      word: false,
    },
    {
      x: 31,
      y: 10,
      w: 0,
      h: wall,
      word: { nl: "Een smartphone", fr: "Un smartphone" },
    },
  ],
};

export const GoodBoxesBase = {
  // White words + boosters

  ///// LEVEL 1 /////
  level1: [
    {
      x: 40,
      y: 70,
      w: 30,
      h: wall,
      word: { nl: "maar de klantendienst", fr: "mais service client" },
      active: true,
    },
    {
      x: 40,
      y: 74,
      w: 30,
      h: wall,
      word: { nl: "is onbereikbaar", fr: "injoignable" },
      active: true,
    },
  ],

  ///// LEVEL 2 /////
  level2: [
    {
      x: 10,
      y: 82,
      w: 30,
      h: wall,
      word: { nl: "maar je kan", fr: "mais que" },
      active: true,
    },
    {
      x: 10,
      y: 86,
      w: 30,
      h: wall,
      word: { nl: "alleen naar", fr: "pour regarder" },
      active: true,
    },
    {
      x: 10,
      y: 90,
      w: 30,
      h: wall,
      word: { nl: "kattenvideo's kijken", fr: "des vidéos de chats" },
      active: true,
    },
    {
      x: 50,
      y: 30,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 60,
      y: 66,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
  ],

  ///// LEVEL 3 /////
  level3: [
    {
      x: 58,
      y: 68,
      w: 30,
      h: wall,
      word: { nl: "naast de router", fr: "près du routeur" },
      active: true,
    },
    {
      x: 4,
      y: 38,
      w: 30,
      h: wall,
      word: { nl: "maar alleen vlak", fr: "mais seulement" },
      active: true,
    },
    {
      x: 42,
      y: 66,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 66,
      y: 14,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 56,
      y: 90,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
  ],

  ///// LEVEL 4 /////
  level4: [
    {
      x: 9,
      y: 13,
      w: 30,
      h: wall,
      word: { nl: "maar ze", fr: "mais" },
      active: true,
    },
    {
      x: 24,
      y: 29,
      w: 32,
      h: wall,
      word: { nl: "smaken", fr: "à la" },
      active: true,
    },
    {
      x: 60,
      y: 83,
      w: 30,
      h: wall,
      word: { nl: "als drop", fr: "réglisse" },
      active: true,
    },
    {
      x: 16,
      y: 63,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 70,
      y: 33,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 60,
      y: 55,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
  ],
  ///// LEVEL 5 /////
  level5: [
    {
      x: 10,
      y: 30,
      w: 30,
      h: wall,
      word: { nl: "maar", fr: "mais" },
      active: true,
    },
    {
      x: 64,
      y: 25,
      w: 30,
      h: wall,
      word: { nl: "zonder", fr: "sans" },
      active: true,
    },
    {
      x: 30,
      y: 70,
      w: 30,
      h: wall,
      word: { nl: "pitjes", fr: "noyaux" },
      active: true,
    },
    {
      x: 35,
      y: 39,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 26,
      y: 82,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 64,
      y: 58,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 86,
      y: 30,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 43,
      y: 54,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
    {
      x: 20,
      y: 50,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
  ],
  ///// LEVEL 6 /////
  level6: [
    {
      x: 15,
      y: 45,
      w: 30,
      h: wall,
      word: { nl: "maar", fr: "mais" },
      active: true,
    },
    {
      x: 70,
      y: 50,
      w: 30,
      h: wall,
      word: { nl: "zonder", fr: "écran" },
      active: true,
    },
    {
      x: 61,
      y: 72,
      w: 30,
      h: wall,
      word: { nl: "scherm", fr: "non-inclus" },
      active: true,
    },
    {
      x: 20,
      y: 72,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 56,
      y: 65,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 82,
      y: 45,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 49,
      y: 25,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 15,
      y: 50,
      w: 3.6,
      h: 2.6,
      type: "speed",
      active: true,
    },
    {
      x: 42,
      y: 65,
      w: 3.6,
      h: 2.6,
      type: "slow",
      active: true,
    },
  ],
};
